export default __webpack_public_path__ + "static/media/OnboardingSuccessPageGraphic.0669fba3.jpg";